"use-strict";

/* @ngInject */
export default function DialogController(
  $scope,
  $window,
  $timeout
) {
  const init = () => {
    $scope.confirmLbl = $scope.confirmLabel !== undefined ? $scope.confirmLabel : 'Okay';
    $scope.exitLbl = $scope.exitLabel !== undefined ? $scope.exitLabel : 'Schließen';
  };

  $scope.exitDialog = () => {
    $scope.exit()();
  };

  $scope.confirmDialog = () => {
    $scope.confirm()();
  };

  init();
}